<template>
  <div ref="wrapper" class="WorldEngine">
    <canvas ref="canvas"></canvas>
  </div>
</template>
<script>
import World from '@/scripts/engine/World'
export default {
  name: 'WorldEngine',
  data() {
    return {
    };
  },
  created() {
  },
  props: {
  },
  components: {},
  mounted() {
    this.$nextTick(() => {
      let w = new World({
        canvas: this.$refs.canvas
      })
    });
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {},
  computed: {
  },
};
</script>
<style src="@/styles/components/WorldEngine.styl" lang="stylus"></style>
